import React, { useState, useEffect } from 'react';
import { useLoadingScreen } from '../../Store/LoadingManager';

import { useNavigate } from "react-router-dom";
import { useSnackbar } from 'notistack';
import { Button, Box } from "@mui/material";

import { IconEye, IconEyeOff } from '@tabler/icons-react';

import { LoginContainer, StyledCard } from '../../Styles/Authentication/authenticationStyles';

import RequiredFieldHelper from '../../Utilities/Helpers/RequiredFieldHelper';
import RequiredParametersHelper from '../../Utilities/Helpers/RequiredParametersHelper';
import LocalStorageHelper from '../../Utilities/Helpers/LocalStorageHelper';

import { RouteEnum } from "../../Utilities/Enums/RouteEnums";
import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import { AuthenticationField } from '../../Utilities/Enums/ParametersEnum';

import { AssetImages } from "../../Constants/Assets";
import { SuccessMessage, ErrorMessage } from '../../Constants/Messages';
import { StaticDisplayText } from '../../Constants/StaticDisplayTexts';

import FormTextField from '../../CustomViews/Elements/FormTextField';
import CustomButton from '../../CustomViews/Elements/CustomButton';

import AuthFooter from './AuthFooter';

import { useAuthenticationHook } from '../../Hooks/Authentication/authenticationHooks';

export default function Login() {
    const { loginUser } = useAuthenticationHook();
    const navigate = useNavigate();
    const requiredParameters = RequiredParametersHelper.authentication();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const { loading, setLoading } = useLoadingScreen();

    const [username, setUsername] = useState(null);
    const [password, setPassword] = useState(null);
    const [errorMessages, setErrorMessages]: any = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [loginResponse, setLoginResponse]: any = useState({});

    //Variables
    const usernameProps = {
        name: 'username',
        title: 'Username',
        placeholder: 'Enter username',
        fieldValue: username,
        type: 'text',
        required: true,
        // hideLabel: true,
        errorMessages: errorMessages,
        handleOnChange: (selectedValue: any) => {
            setUsername(selectedValue);
        },
    },
        passwordProps = {
            name: 'password',
            title: 'Password',
            placeholder: 'Enter password',
            fieldValue: password,
            type: (showPassword ? 'text' : 'password'),
            required: true,
            // hideLabel: true,
            hasIcon: true,
            iconPosition: 'end',
            icon: (showPassword ? <IconEyeOff /> : <IconEye />),
            errorMessages: errorMessages,
            onClickIconTrigger: () => {
                setShowPassword(!showPassword);
            },
            handleOnChange: (selectedValue: any) => {
                setPassword(selectedValue);
            },
        };

    
    //Event Handlers
    const handleLogin = async () => {
        LocalStorageHelper.clearLocalStorage();

        setLoginResponse({ isLoading: true, data: null, errorMessage: '' });

        let loginFormData = { [AuthenticationField.USERNAME]: username, [AuthenticationField.PASSWORD]: password };
        let _validateForm = RequiredFieldHelper.validateForm(requiredParameters, loginFormData, errorMessages, setErrorMessages, enqueueSnackbar);

        if (_validateForm?.hasError) { return true; }

        setLoading(true);

        var response = await loginUser(loginFormData);

        if (response && response.isSuccess && response.data) {
            navigate((response?.data?.data?.requiresTwoFactor ? RouteEnum.OTP : RouteEnum.DASHBOARD), { replace: true });
            navigate(0);

            response.errorMessage = (response && response.data && response.data.message && response.data.message != null && response.data.message != "" ?
                response.data.message : SuccessMessage.LOGIN_SUCCESSFULLY
            );
        } else {
            response.errorMessage = response?.message ?? ErrorMessage.SERVER_ERROR
        }

        setLoading(false)
        response.errorCode = (response.isSuccess ? 200 : 400);

        setLoginResponse({ ...response, isLoading: false });
    }
    
    useEffect(() => {
        LocalStorageHelper.clearLocalStorage();
    }, []);

    return <LoginContainer className='glossy-box'>
        <div className="loginBgContainer">
            <StyledCard elevation={3}>
                <div className="loginFormContainer">
                    <div className="formContainer">
                        <img src={AssetImages.WEB_APP_LOGO} />
                        <div className="formHeader">
                            <div className="spacer"  />
                            <div className="headerText">{StaticDisplayText.APP_HEADER}</div>
                            <div className="spacer" />
                        </div>

                        <FormTextField {...usernameProps} />
                        <FormTextField {...passwordProps} />
                        <div className="forgotPasswordLink" onClick={() => { navigate(RouteEnum.FORGOT_PASSWORD, { replace: true }); }}>Forgot password?</div>

                        <CustomButton
                            btnType={ButtonType.PRIMARY}
                            title='Sign In'
                            className="loginBtn"
                            onClick={(e: any) => {
                                handleLogin();
                            }} />

                        <div className="signUpContainer">
                            <span>New User? Please</span>
                            <div className="signUpLink" onClick={() => { navigate(RouteEnum.SIGN_UP, { replace: true }); }}>Sign Up</div>
                        </div>

                        {loginResponse?.message &&
                            <Box
                                sx={{ typography: 'subtitle2' }}
                                className={`loginErrorMessage${(loginResponse?.errorCode && loginResponse.errorCode == '200' ? ' successMessage' : ' errorMessage')}`} >
                                {loginResponse.message}
                            </Box>
                        }
                    </div>

                    <div className="spacer2" />
                    
                    <AuthFooter />
                </div>
            </StyledCard>
        </div>
    </LoginContainer>
}